import React from 'react';
import { Status, StatusValue } from '../../../domain/status';
import { useId } from '../../../hooks/useId';
import { useTranslation } from 'react-i18next';
import { Meter } from './Meter';
import { createUseStyles } from 'react-jss';
import barfImage from '../../../assets/images/status/barf.png';
import crazyImage from '../../../assets/images/status/crazy.png';
import headacheImage from '../../../assets/images/status/headache.png';
import sickImage from '../../../assets/images/status/sick.png';
import sleepingImage from '../../../assets/images/status/sleeping.png';

export interface IStatusMonitorProps {
    status: Status;
}

interface IStatusMonitorRowProps {
    value: StatusValue<any>;
}

const useStyles = createUseStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
    },
    imageContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexBasis: '35%',
        flexGrow: 0,
    },
    image: {
        width: '60%',
    },
    meters: {
        flexGrow: 1,
    },
});

const StausMonitorRow: React.FunctionComponent<IStatusMonitorRowProps> = (props) => {
    const { t } = useTranslation();
    const id = useId('label');
    const styles = useStyles();

    if (typeof props.value.value !== 'number') {
        return null;
    }

    return <div>
        <span id={id}>{t(`game.status.${props.value.key}.name`)}</span>
        <Meter
            min={props.value.min}
            max={props.value.max}
            value={props.value.value}
            aria-labelledby={id}
            color={props.value.color}
        />
    </div>;
};

const dominantStatus = (status: Status): StatusValue<any> => {
    const values = Object.values(status);
    let dominant = 0;
    let state = values[0];

    values.forEach((value) => {
        const diff = Math.abs(value.optimal - value.value) / (value.max - value.min);
        if (diff > dominant) {
            dominant = diff;
            state = value;
        }
    });

    return state;
};

export const StatusMonitor: React.FunctionComponent<IStatusMonitorProps> = ({ status }) => {

    const dominant = dominantStatus(status);
    const styles = useStyles();

    const image = (() => {
        switch (dominant.key) {
            case 'hp':
                return sickImage;
            case 'happiness':
                return crazyImage;
            case 'sickness':
                return barfImage;
            case 'bloodPressure':
                return headacheImage;
        }})();

    return <div className={styles.root} id="statusmonitor">
        <div className={styles.imageContainer}>
            <img className={styles.image} src={image} alt="barf" />
        </div>
        <div className={styles.meters}>
            {
                Object.entries(status).map(([ key, value ]) =>
                    <StausMonitorRow value={value} key={key}/>,
                )
            }
        </div>
    </div>;
};
